import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, Paper, Typography } from '@mui/material';
import { Button } from '~/components/Button';

export const chatGptPluginUrl =
  'https://chatgpt.com/plugins/plugin_asdk_app_6ac706071cb0819187e890b120047159';

export const ChatGptPluginCta = () => {
  return (
    <Paper
      variant="outlined"
      square
      sx={{
        maxWidth: 740,
        mx: 'auto',
        p: 2,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        gap: 2,
      }}>
      <Box sx={{ flexGrow: 1 }}>
        <Typography variant="h6">NerdyData is now in ChatGPT</Typography>
        <Typography variant="body2" color="text.secondary">
          Add the official NerdyData plugin to search websites by technology,
          look up tech stacks, and export lead lists right inside ChatGPT. No
          setup required.
        </Typography>
      </Box>
      <Button
        variant="contained"
        disableElevation
        href={chatGptPluginUrl}
        target="_blank"
        endIcon={<OpenInNewIcon />}
        sx={{ flexShrink: 0 }}>
        Add to ChatGPT
      </Button>
    </Paper>
  );
};
